// @ts-ignore
import fraudProtectionSystem from "@/plugins/fraudProtectionSystem.js"

export const useFraudProtectionSystem = () => {
  fraudProtectionSystem()
}

export default useFraudProtectionSystem
